import { get, httpDelete, patch, post, put } from '../../utils/http';

export const fetchAccount = ({ accountId }) =>
  get(`/accounts/${accountId}`, {
    includes: [
      'withCurrency',
      'withLanguage',
      'withCountry',
      'withPayrollConfig',
      'withCustomSettings',
      'withOrganization'
    ]
  });

export const fetchAccountConfig = ({ accountId, getNextPayment }) =>
  get(`/accounts/${accountId}`, {
    includes: ['withConfig', 'withPayrollConfig', 'withHolidays', 'withCRMConfig', 'withOrganization'],
    getNextPayment
  });

export const updateAccountConfig = ({ accountId, account }) => patch(`/accounts/${accountId}`, account);

export const fetchAvailabilities = ({ accountId, start, end, branches, employeeIds }) =>
  get(`/accounts/${accountId}/availabilities`, { start, end, branches, employeeIds });

export const updateAvailabilities = ({ accountId, body }) => put(`/accounts/${accountId}/availabilities`, body);

export const upsertAccountChatRoom = ({ accountId }) => put(`/accounts/${accountId}/chatrooms`);

export const fetchCompliances = ({ accountId, positionId, branchIds, isActive }) =>
  get(`/accounts/${accountId}/compliances`, { positionId, branchIds, isActive });

export const fetchFeatureGate = ({ accountId }) => get(`/accounts/${accountId}/feature-gate`);

export const getFilters = ({ accountId }) => get(`/accounts/${accountId}/filters`);

export const fetchFiscalPeriods = ({ accountId }) => get(`/accounts/${accountId}/fiscal-periods`);

export const addFiscalPeriod = ({ accountId, ...params }) => post(`/accounts/${accountId}/fiscal-periods`, params);

export const fetchGeneralAvailabilities = ({ accountId, employeeIds }) =>
  get(`/accounts/${accountId}/general-availabilities`, { employeeIds });

export const updateGeneralAvailability = ({ accountId, boards }) =>
  put(`/accounts/${accountId}/general-availabilities`, { boards });

export const fetchLabels = ({ accountId }) => get(`/accounts/${accountId}/labels`);

export const fetchLocations = ({ accountId }) => get(`/accounts/${accountId}/locations`, { withIsDeleted: true });

export const fetchActiveAccountModules = ({ accountId }) => get(`/accounts/${accountId}/modules`);

export const updateModules = ({ accountId, modules }) => put(`/accounts/${accountId}/modules`, { moduleIds: modules });

export const fetchAccountProfile = ({ accountId }) => get(`/accounts/${accountId}/profile`);

export const updateAccountProfile = ({ accountId, profile }) => put(`/accounts/${accountId}/profile`, { ...profile });

export const fetchTimeAvailabilities = ({ accountId, branchIds, from, to }) =>
  get(`/accounts/${accountId}/timeAvailabilities`, { branchIds, from, to });

export const fetchEmployeesTimeAvailabilities = ({ accountId, branchIds, from, to, employeeIds }) =>
  get(`/accounts/${accountId}/timeAvailabilities`, { branchIds, from, to, employeeIds });

export const addTimeAvailabilities = ({ accountId, timeAvailabilities, employeeId }) =>
  post(`/accounts/${accountId}/timeAvailabilities`, { timeAvailabilities, employeeId });

export const fetchUniforms = ({ accountId }) => get(`/accounts/${accountId}/uniforms`);

export const updateWage = ({ accountId, wageId, wage }) => patch(`/accounts/${accountId}/wages/${wageId}`, wage);

export const tempFix = () => post(`/accounts/tempFix`);

export const addBillingMethod = ({ accountId, body }) => post(`accounts/${accountId}/billing/methods`, body);

export const fetchReport = ({
  accountId,
  reportId,
  fromDate,
  toDate,
  invoiceNumber,
  payrollModes,
  branches,
  selectedColumns,
  workerType
}) =>
  post(`accounts/${accountId}/reports/${reportId}`, {
    fromDate,
    toDate,
    invoiceNumber,
    payrollModes,
    branches,
    selectedColumns,
    workerType
  });

export const fetchReportColumns = ({ accountId, reportId }) => get(`accounts/${accountId}/reports/${reportId}/columns`);

export const deleteTimeAvailability = ({ accountId, timeAvailabilityId }) =>
  httpDelete(`/accounts/${accountId}/timeAvailabilities/${timeAvailabilityId}`);

export const deleteTimeOff = ({ accountId, timeOffId }) => httpDelete(`/accounts/${accountId}/timeoffs/${timeOffId}`);

export const addAccount = (params) => post('/accounts', params);

export const fetchRankingBadges = ({ accountId }) => get(`/accounts/${accountId}/ranking-badges`);
